module.exports = __webpack_public_path__ + "static/media/Cask_BG.4129aaab.png";